import config from 'react-global-configuration';
import { referenceLoadingStart, referenceLoadingDone } from '../../UI/ReferenceLoading';
export var nodeGet = function nodeGet(nodeId) {
  var viewMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  return function (dispatch, getState) {
    dispatch(referenceLoadingStart());
    var API_URL = config.get('API_URL');
    var language = getState().getIn(['ui', 'language']);
    var MULTILINGUAL = config.get('MULTILINGUAL', true);
    var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
    var credentials = getState().getIn(['ui', 'fetch', 'credentials', 'node']) || getState().getIn(['ui', 'fetch', 'credentials', 'content'], 'include');
    var headers = getState().getIn(['ui', 'fetch', 'headers', 'content']);
    fetch("".concat(PATH, "/node/").concat(nodeId, "?_format=json&viewMode=").concat(viewMode), {
      credentials: credentials,
      headers: headers
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      dispatch(nodeGetLoaded(nodeId, response));
      dispatch(referenceLoadingDone());
    }).catch(function () {
      dispatch(referenceLoadingDone());
    });
  };
};
export var NODE_GET_LOADED = 'NODE_GET_LOADED';
export function nodeGetLoaded(nodeId, data) {
  return {
    type: NODE_GET_LOADED,
    node_id: nodeId,
    data: data
  };
}